export const APP_TITLE = "Videonalejvárny.cz od Fífy";
